// Rupee amounts in words, Indian numbering (Thousand, Lakh, Crore):
// 1250000.5 → "Twelve Lakh Fifty Thousand Rupees and Fifty Paise"

const UNITS = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten',
  'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
const TENS = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

const belowHundred = (n) => (n < 20 ? UNITS[n] : TENS[Math.floor(n / 10)] + (n % 10 ? ` ${UNITS[n % 10]}` : ''));

const belowThousand = (n) => {
  if (n < 100) return belowHundred(n);
  const rest = n % 100;
  return `${UNITS[Math.floor(n / 100)]} Hundred${rest ? ` and ${belowHundred(rest)}` : ''}`;
};

// Whole numbers (0 and up) in words
export const numberToWords = (num) => {
  let n = Math.floor(Math.abs(Number(num) || 0));
  if (n === 0) return 'Zero';
  const parts = [];
  const crore = Math.floor(n / 10000000);
  if (crore) {
    parts.push(`${numberToWords(crore)} Crore`); // 100+ crore reads as "One Hundred Crore"
    n %= 10000000;
  }
  const lakh = Math.floor(n / 100000);
  if (lakh) {
    parts.push(`${belowHundred(lakh)} Lakh`);
    n %= 100000;
  }
  const thousand = Math.floor(n / 1000);
  if (thousand) {
    parts.push(`${belowHundred(thousand)} Thousand`);
    n %= 1000;
  }
  if (n) parts.push(belowThousand(n));
  return parts.join(' ');
};

// '' when there is nothing sensible to show (empty, not a number, zero, absurdly large)
export const amountInWords = (value) => {
  if (value === null || value === undefined || value === '') return '';
  const amount = Number(String(value).replace(/,/g, ''));
  if (!Number.isFinite(amount) || amount === 0 || Math.abs(amount) >= 1e15) return '';

  const totalPaise = Math.round(Math.abs(amount) * 100);
  const rupees = Math.floor(totalPaise / 100);
  const paise = totalPaise % 100;

  const parts = [];
  if (rupees) parts.push(`${numberToWords(rupees)} ${rupees === 1 ? 'Rupee' : 'Rupees'}`);
  if (paise) parts.push(`${numberToWords(paise)} Paise`);
  if (!parts.length) return '';
  return `${amount < 0 ? 'Minus ' : ''}${parts.join(' and ')}`;
};
